export default {
  authenticated: false,
  token: null,
  availableLines: [],
  role_id: null,
  role_name: null,
  is_admin: null,
  plants: [],
  user: null,
  password: null,
  mini:false,
  sub_menu:false,
  sub_menu_dashboard:false,
  client:null,
  password_expires:null,
  has_dashboards:null
}
